export const nbNO = {
  common: {
    tryAgain: 'Prøv igjen',
    contactUs: 'Kontakt oss',
    loginIn: 'Logg inn på Mine Sider',
    forgotPassword: 'Glemt passord',
    notACustomer: 'Ikke kunde enda?',
    becomeAcustomer: 'Bli kunde',
    back: '< Tilbake',
  },
  crmBlocked: {
    title: 'Beklager!',
    ingress: 'Grunnet vedlikehold er det ikke mulig å registrere ny bruker hos {partnerName} akkurat nå. Prøv igjen om en liten stund!',
    emoji: '😑',
    emojiLabel: 'uttrykksløs-emoji',
    description: '',
  },
  systemError: {
    title: 'Uff da..',
    ingress: 'Her gikk det <strong>skikkelig galt</strong>',
    emoji: '💩',
    emojiLabel: 'Bæsj-emoji',
  },
  timeOut: {
    title: 'For mange forsøk',
    ingress: 'Prøv igjen om <strong>10 minutter</strong>',
    emoji: '😬',
    emojiLabel: 'Grimase-emoji',
    description:
      'For å sikre dine og andre kunders data, tillater vi ikke mer enn 10 forsøk i løpet av 10 minuter. Forsøk igjen senere, eller ta kontakt med oss dersom du har behov for hjelp.',
  },
  userCreated: {
    title: 'Sjekk e-posten din!',
    ingress: 'Vi har <strong>sendt deg en e-post</strong> med instruksjoner for å sette passord til:',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
  },
  pinSent: {
    title: 'Sjekk e-posten din!',
    ingress: 'Din PIN-kode er sendt til e-postadressen din. Trykk på knappen nedenfor for å komme tilbake til opprettelse av bruker.',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
    createUserButton: 'Opprett bruker',
  },
  userCreateFailed: {
    title: 'Oisann!',
    ingress: 'Beklager. En <strong>liten glipp</strong> fra oss.',
    emoji: '😬',
    emojiLabel: 'Grimase-emoji',
    description: 'Ta kontakt hvis feilen vedvarer, men først:',
  },
  userExist: {
    title: 'Hei igjen!',
    ingress: 'Du <strong>har allerede en bruker</strong> hos oss.',
    emoji: '🤗',
    emojiLabel: 'Klemmefjes-emoji',
  },
  userMultipleMatches: {
    title: 'Ojsann...',
    ingress: 'Vi fant <strong>flere kundeforhold</strong> med din e-post:',
    emoji: '🤓😎',
    emojiLabel: 'Nerdefjes-emoji og Solbrillefjes-emoji',
    description: 'Våre systemer klarer desverre ikke å se hvem som er hvem og du må derfor få hjelp av oss til å fullføre prosessen.',
  },
  mailVerificationSent: {
    title: 'Sjekk e-posten din!',
    ingress: 'Vi har sendt deg en ny e-post. Følg instruksjonene i denne for å fullføre registreringen.',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
  },
  userNotFound: {
    title: 'Hmmm...',
    ingress: 'Vi <strong>fant deg ikke</strong> med denne informasjonen',
    emoji: '🤔',
    emojiLabel: 'Tenkefjes-emoji',
    partnerLabel: 'Partner:',
    phoneLabel: 'Mobilnummer:',
    emailLabel: 'E-post:',
    customerNumberLabel: 'Kundenummer:',
    pinLabel: 'PIN:',
  },
  userSubmit: {
    title: 'Få tilgang',
    ingress: 'La oss finne deg i systemene våre.',
    formfieldPhoneLabel: 'Mobilnummer',
    formfieldEmailLabel: 'E-post',
    formfieldCustomerNumberLabel: 'Kundenummer',
    formfieldPinLabel: 'PIN',
    formSubmitButtonText: 'Gå videre',
    legacyHelp: 'Kundenummeret finner du på faktura fra din Altibox-leverandør og PIN-kode i kundebrevet du mottok da du ble kunde.',
    legacyPinLink: 'Har du ikke PIN-kode?',
  },
  pinVerified: {
    defaultTitle: 'Fant deg!',
    titlePersonalized: 'Hei, {accountFirstName}!',
    ingress: 'Nå må du fylle inn e-postadressen din og velge et passord.',
    emoji: '🤗',
    emojiLabel: 'Klemmefjes-emoji',
    buttonSubmitText: 'Opprett bruker',
    formfieldEmailLabel: 'E-post',
    formfieldPasswordLabel: 'Passord',
    formValidationFeedback: {
      emailInvalid: 'E-postadressen er ikke gyldig. Har du skrevet den riktig?',
      passwordInvalid: 'Passordet er for svakt',
    },
    passwordRules: 'Passordet må bestå av minst åtte tegn og oppfylle minst tre av følgende kriterier: tall, spesialtegn, store bokstaver, små bokstaver.',
    passwordOk: 'Passordet er godkjent',
    showPasswordLabel: 'Vis',
    hidePasswordLabel: 'Skjul',
    capsLockWarning: 'NB! Caps lock er påslått!',
    usernameTaken: 'E-postadressen er allerede registrert',
  },
  offCode: {
    title: 'Nesten ferdig!',
    ingress: 'Vi har sendt deg e-post for å bekrefte e-postadressen. Du kan trykke på lenken i e-posten, eller sende inn koden her:',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
    offcodeLabel: 'Engangskode:',
    buttonSubmitText: 'Bekreft',
    formValidationFeedback: {
      offcode: 'Koden må være fem siffer.',
    },
    invalidOffcode: 'Feil kode. Sjekk at du har skrevet den riktig.',
  },
  userFinalized: {
    title: 'Suksess!',
    ingress: 'Bruker opprettet! Nå kan du logge inn på Mine sider',
    emoji: '🥳',
    emojiLabel: 'Fest-emoji',
    buttonText: 'Gå til Mine sider',
  },
  spinner: {
    pleaseWait: 'Vennligst vent',
  },
  apiAuthenticationErrors: {
    NoAccessableAccount: 'Doesn\'t match any accessible account', // 6001
    MissingInput: 'Missing input', // 6002
    UserNotAuthenticated: 'User not authenticated', // 6003
  },
  forgotPin: {
    title: 'Mangler du PIN-kode?',
    emoji: '🤔',
    emojiLabel: 'Tenkefjes-emoji',
    ingress: 'Velg din Altibox-leverandør og fyll inn kundenummer for å få tilsendt PIN-kode til din registrerte e-postadresse.</p><p>Kundenummer finner du på faktura fra din Altibox-leverandør og i kundebrevet eller SMSen du mottok da du ble kunde.',
    buttonText: 'Send meg PIN-kode',
    formCustomerNumberLabel: 'Ditt kundenummer',
    invalidCustomerNumber: 'Kundenummeret er ikke gyldig. Har du skrevet det riktig?',
  },
  partnerSelect: {
    label: 'Velg din Altibox-leverandør',
    defaultOptionText: '-- Velg partner --',
    validationMessage: 'Du må velge hvilken partner du er kunde hos.',
  },
  validationSummary: {
    title: 'Oi, noe er ikke helt rett med skjemaet.',
    formValidationFeedback: {
      partnerNumberInvalid: 'Du må velge hvilken partner du er kunde hos.',
      mobileNumberInvalid: 'Mobilnummer må ha 8 siffer.',
      emailInvalid: 'E-postadressen er ikke gyldig. Har du skrevet den riktig?',
      customerNumberInvalid: 'Kundenummeret er ikke gyldig. Har du skrevet det riktig?',
      pinInvalid: 'PIN-koden er ikke gyldig. Den må være fire sifre.',
    },
  },
  cardHeader: {
    altiboxUrl: 'https://www.altibox.no/',
    logoAlt: 'Til forsiden av altibox.no',
  },
};

export type TextConfigDefault = typeof nbNO;

/*
    6004: 'User already exists for the customer',
    6005: 'Expected another CRM system',
    6006: 'Username is not a valid email address',
    6007: 'Invalid token',
    6008: 'Invalid offcode',
    6009: 'Ticket has expired',
    6010: 'Password not strong enough',
    6011: 'Could not find contact id',
    6012: 'Unable to check if username exists',
    6013: 'Username taken',
    6014: 'Failed to initialize email account',
    6015: 'Failed to set password for email account',
    6016: 'Failed to create user',
    6017: 'Failed to send email',
    */
